import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCompositionService, fetchCropsService, fetchFormulationTypesService, fetchProblematicsService, fetchFamiliesService } from "../services";

export const fetchFamilies = createAsyncThunk("filters/fetchFamilies",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchFamiliesService();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchCrops = createAsyncThunk("filters/fetchCrops",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchCropsService();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchActiveIngredients = createAsyncThunk("filters/fetchActiveIngredients",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchCompositionService();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    });

export const fetchProblematics = createAsyncThunk("filters/fetchProblematics", async (_, { rejectWithValue }) => {
    try {
        const data = await fetchProblematicsService();
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const fetchFormulationTypes = createAsyncThunk("filters/fetchFormulationTypes",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchFormulationTypesService();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    });

// Slice
const filtersSlice = createSlice({
    name: "products_filters",
    initialState: {
        crops: [],
        activeIngredients: [],
        problematics: [],
        formulationTypes: [],
        families: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFamilies.fulfilled, (state, action) => {
                state.families = action.payload;
            })
            .addCase(fetchCrops.fulfilled, (state, action) => {
                state.crops = action.payload;
            })
            .addCase(fetchActiveIngredients.fulfilled, (state, action) => {
                state.activeIngredients = action.payload;
            })
            .addCase(fetchProblematics.fulfilled, (state, action) => {
                state.problematics = action.payload;
            })
            .addCase(fetchFormulationTypes.fulfilled, (state, action) => {
                state.formulationTypes = action.payload;
            });
    },
});

export default filtersSlice.reducer;
